import { CompassPoint, CompassPoints, CompassPointType } from 'server/enums/CompassPoint';

// TH: A typescript port of CompassPointExtensions from PortCall.Models\Utils\CompassPoint.cs
export const COMPASS_SIZE = 32;

export function PointsOfType(type : CompassPointType) : CompassPoint[] {
    return CompassPoints.map(item => item.Id).filter(compass => (type & PointType(compass)) !== 0);
}

export function PointType(compass : CompassPoint) {
    return compass % CompassPointType.Cardinal                  === 0 ? CompassPointType.Cardinal
            : compass % CompassPointType.Ordinal                === 0 ? CompassPointType.Ordinal
            : compass % CompassPointType.SecondaryInterCardinal === 0 ? CompassPointType.SecondaryInterCardinal
            : CompassPointType.QuarterWind;
}

export function Abbreviation(compass : CompassPoint) {
    return compass === CompassPoint.North ? "N"
            : compass === CompassPoint.NorthByEast ? "NbE"
            : compass === CompassPoint.NorthNorthEast ? "NNE"
            : compass === CompassPoint.NorthEastByNorth ? "NEbN"
            : compass === CompassPoint.NorthEast ? "NE"
            : compass === CompassPoint.NorthEastByEast ? "NEbE"
            : compass === CompassPoint.EastNorthEast ? "ENE"
            : compass === CompassPoint.EastByNorth ? "EbN"
            : compass === CompassPoint.East ? "E"
            : compass === CompassPoint.EastBySouth ? "EbS"
            : compass === CompassPoint.EastSouthEast ? "ESE"
            : compass === CompassPoint.SouthEastByEast ? "SEbE"
            : compass === CompassPoint.SouthEast ? "SE"
            : compass === CompassPoint.SouthEastBySouth ? "SEbS"
            : compass === CompassPoint.SouthSouthEast ? "SSE"
            : compass === CompassPoint.SouthByEast ? "SbE"
            : compass === CompassPoint.South ? "S"
            : compass === CompassPoint.SouthByWest ? "SbW"
            : compass === CompassPoint.SouthSouthWest ? "SSW"
            : compass === CompassPoint.SouthWestBySouth ? "SWbS"
            : compass === CompassPoint.SouthWest ? "SW"
            : compass === CompassPoint.SouthWestByWest ? "SWbW"
            : compass === CompassPoint.WestSouthWest ? "WSW"
            : compass === CompassPoint.WestBySouth ? "WbS"
            : compass === CompassPoint.West ? "W"
            : compass === CompassPoint.WestByNorth ? "WbN"
            : compass === CompassPoint.WestNorthWest ? "WNW"
            : compass === CompassPoint.NorthWestByWest ? "NWbW"
            : compass === CompassPoint.NorthWest ? "NW"
            : compass === CompassPoint.NorthWestByNorth ? "NWbN"
            : compass === CompassPoint.NorthNorthWest ? "NNW"
            : "NbW";
}

// Opposite side of the compass
export function Antipode(compass : CompassPoint) : CompassPoint {
    return (compass + COMPASS_SIZE / 2) % COMPASS_SIZE;
}


// WEBPACK FOOTER //
// ./data/models/CompassPointExtensions.ts